import React from 'react';
import { m } from 'motion/react';
import { useSeoHead } from '../hooks/useSeoHead';
import { getRoutePair, hreflangFor, SITE_URL } from '../seoRoutes';

const PAIR = getRoutePair('gtc');

const AGB = () => {
  useSeoHead({
    title: PAIR.de.title,
    description: PAIR.de.description,
    canonical: `${SITE_URL}${PAIR.de.path}`,
    indexable: PAIR.indexable,
    htmlLang: 'de',
    hreflang: hreflangFor(PAIR),
  });

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl font-display font-bold mb-8 text-pstax-navy">Allgemeine Geschäftsbedingungen (AGB)</h1>
          
          <div className="prose prose-lg prose-pstax max-w-none text-pstax-gray">
            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">1. Geltungsbereich</h2>
              <p>Die folgenden Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen zwischen der PSTax Steuerberatung FlexCo und unseren Klient:innen in der zum Zeitpunkt des Vertragsschlusses gültigen Fassung.</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">2. Gegenstand des Vertrages</h2>
              <p>Wir bieten Steuerberatungsdienstleistungen, Buchführung, Gründungsberatung, die Erstellung von Steuererklärungen und damit verbundene Dienstleistungen für Selbstständige und Unternehmen in Österreich an.</p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">3. Berufsstandards</h2>
              <p>Unsere Tätigkeit erfolgt nach den berufsrechtlichen Standards für Steuerberater und Wirtschaftsprüfer in Österreich (AAB der KSW). Die "Allgemeinen Auftragsbedingungen für Wirtschaftstreuhandberufe" (AAB) in der jeweils geltenden Fassung bilden einen integralen Bestandteil unseres Vertragsverhältnisses.</p>
              <div className="mt-4">
                <a href="https://old.ksw.or.at/PortalData/1/Resources/aab/AAB_2018_de.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-pstax-blue font-bold hover:underline">
                  Allgemeine Auftragsbedingungen (AAB) PDF herunterladen
                </a>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-display font-bold text-pstax-navy mb-4">4. Digitale Methoden</h2>
              <p>PSTax ist eine digital-orientierte Kanzlei. Der Kunde stimmt der Nutzung digitaler Kommunikationswege und der bereitgestellten Tools für den Belegaustausch und die Zusammenarbeit zu, sofern nicht schriftlich etwas anderes vereinbart wurde.</p>
            </section>

            <section className="mb-12 text-sm italic">
              <p>Hinweis: Die rechtlich bindende Fassung unserer Bedingungen ist die deutsche Version und die von der Kammer der Steuerberater und Wirtschaftsprüfer herausgegebenen professionellen AAB (Allgemeine Auftragsbedingungen).</p>
            </section>
          </div>
        </m.div>
      </div>
    </div>
  );
};

export default AGB;
